import { ReactNode } from 'react';

import MUIGrid, { GridDirection, GridWrap } from '@mui/material/Grid';
import classNames from 'classnames';

import {
  Spacing,
  GridContentAlignment,
  GridItemsAlignment,
  GridJustification,
} from '../Grid.types';

import { useStyles } from './GridContainer.styles';

interface GridContainerProps {
  alignContent?: GridContentAlignment;
  alignItems?: GridItemsAlignment;
  children?: ReactNode;
  direction?: GridDirection;
  justifyContent?: GridJustification;
  spacing?: Spacing;
  wrap?: GridWrap;
}

export const GridContainer = ({ children, ...props }: GridContainerProps) => {
  const { classes } = useStyles(props);

  return (
    <MUIGrid
      classes={{
        root: classNames(classes.container, {
          [classes.spacing]: !!props.spacing,
        }),
      }}
      {...props}
      container
    >
      {children}
    </MUIGrid>
  );
};
